

let gallery = {
    init: (container = document) => {
        $(container).find('.gallery-btn').on('click', function() {
            //console.log("!")
        
            let $this = $(this);
            let id = $this.data('id');
            $('.gallery-btn').removeClass('active');
            $this.addClass("active");
            $('.gallery-image').removeClass('active');
            $(`#${id}`).addClass('active');
            
        });
    }
}

gallery.init($('.gallery-page'));